import { FeathersModel } from './feathersModel'
import { ContractType } from './contractType'
import { Worker } from './worker'
import { DateUtils } from '../services/date-utils.service'

export class Contract extends FeathersModel {
  static serviceName = 'contracts'

  workerId: number
  contractTypeId: number
  worker: Worker
  contractType: ContractType
  fte: number
  aliasWorkPositionId: number
  levelOfEmploymentMonthlyHours: number
  trialPeriodEndDate: Date
  terminationDate: Date
  terminationReason: string
  appliesTaxPayerDeclaration: boolean
  appliesDiscountForDisabilityOfFirstOrSecondDegree: boolean
  appliesDiscountForDisabilityOfThirdDegree: boolean
  appliesDiscountOnZTPP: boolean
  spouseFirstName: string
  spouseLastName: string
  spouseBirthNumber: string
  appliesDiscountOnSpouse: boolean
  otherBreadwinnerFirstName: string
  otherBreadwinnerLastName: string
  otherBreadwinnerBirthNumber: string
  isOtherBreadwinnerIsProvidingForChildren: boolean
  validFrom: Date
  validTo: Date | null
  currentlyActive: boolean = false

  updateFromProps(props): this {
    super.updateFromProps(props)

    this.validFrom = new Date(this.validFrom)
    this.validTo = this.validTo ? new Date(this.validTo) : null
    this.trialPeriodEndDate = this.trialPeriodEndDate ? new Date(this.trialPeriodEndDate) : null
    this.terminationDate = this.terminationDate ? new Date(this.terminationDate) : null

    return this
  }

  /**
   * Expects a collection of all contracts on a user. Computes the contract that should be currently active, based on current date and a transparent set of rules.
   * @param contracts A collection of Contract objects with a common userId
   */
  static computeCurrentlyActiveContract(contracts: Contract[]): Contract {
    return this.computeActiveContractForDate(contracts, new Date())
  }

  static computeActiveContractForDate(contracts: Contract[], date: Date): Contract {
    // console.log('computeActiveContractForDate', contracts, date)
    if (!contracts) return

    const workerId = contracts[0].workerId

    if (contracts.some((c) => c.workerId !== workerId)) {
      console.error('Invalid argument contracts supplied, contracts originate from multiple workers', contracts)
      throw new Error('Invalid argument supplied')
    }

    return (
      contracts
        .filter((c) => DateUtils.isInRange(date, { from: c.validFrom, to: c.validTo }))
        // Get minimum range
        .reduce((prevContract, contract) => {
          // console.log(prevContract, contract)
          if (!prevContract) return contract
          return prevContract.validFrom > contract.validFrom ? prevContract : contract
        }, null)
    )
  }
}
